import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	DeleteRefundProcedure,
	DeleteRefundProcedureResponse,
} from 'domain/usecases/private/refund/request/delete-procedure';

export class RemoteRefundDeleteProcedure implements DeleteRefundProcedure {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<DeleteRefundProcedureResponse>,
	) {}

	async delete(): Promise<DeleteRefundProcedureResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'delete',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
